module.exports = __webpack_public_path__ + "img/generica_summer.a65d6cfc.svg";